export default __webpack_public_path__ + "static/media/LOGOTIPO CASSU 2019.58a1ddd1.svg";